import { PublicKey } from '@solana/web3.js';
import { GLOBAL_CONFIG_SEED, PROGRAM_ID } from '../programConstants';

const textEncoder = new TextEncoder();

export function getGlobalConfigPda() {
  const [publicKey] = PublicKey.findProgramAddressSync(
    [textEncoder.encode(GLOBAL_CONFIG_SEED)],
    PROGRAM_ID
  );

  return publicKey;
}
